import React from 'react'

const Innovation = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/innovation',
  ...props
}) => (
  <svg height='75' width='121' viewBox='0 0 121 75' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        stroke={primaryColor}
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M59.75 60.5v-40l40 40h-80' />
      <path
        d='M67.75 60.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0'
        fill={secondaryColor} />
      <path
        d='M65.5 14.75a5.75 5.75 0 1 1-11.5 0 5.75 5.75 0 1 1 11.5 0M111.5 60.75a5.75 5.75 0 1 1-11.5 0 5.75 5.75 0 1 1 11.5 0M19.5 60.75a5.75 5.75 0 1 1-11.5 0 5.75 5.75 0 1 1 11.5 0'
        stroke={primaryColor}
        strokeWidth='2.25' />
    </g>
  </svg>
)

export default Innovation
